export function faqSchema(faq) {
  if (!faq.length) {
    return;
  }
  const array = faq.flatMap((items) => {
    return items.questions.map((question) => {
      return {
        '@type': 'Question',
        name: question.question,
        acceptedAnswer: {
          '@type': 'Answer',
          text: question.answer,
        },
      };
    });
  });
  const jsonLinkedData = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: array,
  };
  document.getElementById('scriptJSON').innerText = JSON.stringify(jsonLinkedData);
}
